export interface BusinessResponseLike {
  code?: unknown;
  status?: unknown;
}

const INTEGER_LIKE_PATTERN = /^-?\d+$/;

const normalizeBusinessValue = (value: unknown) => {
  if (typeof value !== 'string') {
    return value;
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return undefined;
  }

  if (INTEGER_LIKE_PATTERN.test(trimmedValue)) {
    return Number(trimmedValue);
  }

  return trimmedValue;
};

export const getBusinessCode = (
  responseData?: BusinessResponseLike | null,
): number | string | undefined => {
  return normalizeBusinessValue(responseData?.code) as
    | number
    | string
    | undefined;
};

export const getBusinessStatus = (
  responseData?: BusinessResponseLike | null,
): number | string | undefined => {
  return normalizeBusinessValue(responseData?.status) as
    | number
    | string
    | undefined;
};

export const hasZeroBusinessSuccess = (
  responseData?: BusinessResponseLike | null,
) => {
  const businessCode = getBusinessCode(responseData);
  const businessStatus = getBusinessStatus(responseData);

  return businessCode === 0 || businessStatus === 0;
};

export const isStandardBusinessSuccess = (
  responseData?: BusinessResponseLike | null,
) => {
  return (
    hasZeroBusinessSuccess(responseData) || getBusinessCode(responseData) === 14
  );
};
